import classNames from 'classnames';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';
import StatusIcon from './StatusIcon';
import { useHideGetItBy, useHideShipping, useShippingCost } from '../hooks';

type OwnProps = {
  getItBy: string;
};

export default function Shipping({ getItBy }: OwnProps) {
  const shippingCost = useShippingCost();
  const hideShipping = useHideShipping();
  const hideDot = useHideGetItBy(getItBy);
  const costText =
    shippingCost > 0 ? `$${formatAndDropDecimal(shippingCost)}` : '';
  const divider = ' • ';
  const shippingText = shippingCost ? `Shipping: ` : 'Free Shipping';

  return (
    <div
      data-qa="shipping-cost"
      className={classNames('flex gap-4 items-center mr-4', {
        hidden: hideShipping
      })}
    >
      {!hideShipping && !shippingCost && <StatusIcon />}
      {shippingText}
      {costText && <span className="font-normal">{costText}</span>}
      {hideDot ? null : divider}
    </div>
  );
}
